<template>
  <AuthShell ref="auth" mode="code">
    <el-form :disabled="submitting || codeBusy" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent="submitForm('ruleForm')">
      <label class="auth-label" for="login-mobile">手机号</label>
      <el-form-item prop="mobile"><el-input id="login-mobile" v-model="ruleForm.mobile" type="tel" autocomplete="tel" placeholder="请输入手机号码" /></el-form-item>
      <label class="auth-label" for="login-code">验证码</label>
      <el-form-item prop="code"><div class="auth-code-field"><el-input id="login-code" v-model="ruleForm.code" autocomplete="one-time-code" placeholder="请输入验证码" /><el-button class="auth-code-button" :disabled="codeBusy || !!times" @click="getCode">{{ codeBusy ? '发送中…' : typeof showCode === 'number' ? showCode + '秒后重试' : showCode }}</el-button></div></el-form-item>
      <el-button :loading="submitting" :disabled="submitting" type="primary" class="auth-submit" native-type="submit">登录</el-button>
    </el-form>
  </AuthShell>
</template>

<script>
import AuthShell from './AuthShell.vue'
import authSecurity from '@/utils/authSecurity'
import { resetAnnouncementForLogin } from '@/utils/homeAnnouncement'
import {setCath, setCathString} from '@/utils/cache'
import {apiSmsLogin} from '@/utils/requestapis'

export default {
  components: { AuthShell },
  mixins: [authSecurity],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (value.length < 11) {
        callback(new Error('请输入完整的手机号'));
      } else {
        callback();
      }
    };
    return {
      showCode:'获取验证码',
      times:false,
      codeBusy:false,
      disposed:false,
      checkList:[],
      activeName:'first',
      ruleForm: {
        mobile: '',
        code: '',
      },
      rules: {
        mobile: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        code: [
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    };
  },
  beforeDestroy() { this.disposed = true; clearInterval(this.times) },
  methods: {
    getCode2(){
      this.showCode--;
      if(this.showCode <= 0){
        this.showCode = '获取验证码';
        clearInterval(this.times);
        this.times = false;
      }
    },
    async getCode() {
      if (this.submitting || this.codeBusy || this.times) return
      if(!/^\d{11}$/.test(this.ruleForm.mobile)){
          this.$message({
            message: '请输入11位手机号',
            type: 'error',
            duration: 5 * 1000
          })
        return 0;
      }
      let param = {
        mobile:this.ruleForm.mobile,
        type:3
      }
      this.codeBusy = true
      try {
        const result = await this.sendVerifiedCode(param.mobile, param.type)
        if (!result || this.disposed) return
        this.showCode = 60
        this.times = setInterval(this.getCode2,1000)
      } catch (_) { /* The shared request handler displays the error. */ }
      finally { this.codeBusy = false }
    },
    handleClick(){
      this.$router.push('/Login').catch(err=>{})
    },
    async submitForm(formName) {
      if (this.submitting || this.codeBusy) return
      this.submitting = true
      try {
        const valid = await new Promise(resolve => this.$refs[formName].validate(resolve))
        if (valid) {
          const captcha = await this.prepareLogin(this.ruleForm.mobile).catch(() => null)
          if (captcha === null) { this.submitting = false; return }
          await apiSmsLogin({ ...this.ruleForm, captcha_code: captcha }).then(async (res) => {
            res = await this.$refs.auth.completeLogin(res)
            if (!res || !res.token) return
            setCathString('TOKEN',res.token)
            setCath('userInfo',res)
            resetAnnouncementForLogin()
            this.$router.push('/').catch(err=>{})

          }).catch(() => {})
        } /*else {
          console.log('error submit!!');
          return false;
        }*/
      } finally { this.submitting = false }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
